export enum EnumTipoAgrupacion {
  Factura = 1,
  Contrato
}
